import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppTranslateService } from './services/translate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    private appTranslate: AppTranslateService,
    private router: Router,
  ) {
    // Re-check ?lang= on every navigation so deep links always apply the param
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
      this.appTranslate.detectFromUrl();
    });
  }
}
